import { render, staticRenderFns } from "./MonthlyTrafficIcon.vue?vue&type=template&id=254088b0&scoped=true"
import script from "./MonthlyTrafficIcon.vue?vue&type=script&lang=js"
export * from "./MonthlyTrafficIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254088b0",
  null
  
)

export default component.exports